module.exports = __webpack_public_path__ + "static/media/naacp.6992e151.png";